import fetchData from 'src/utils/fetchData';

export const getMerchantsAPI = async (organizationUeid: string, bankUeid: string) => {
  return fetchData(
    `/ui/front-api/private/organizations/${organizationUeid}/banks/${bankUeid}/merchants`
  );
};

export const refreshMerchantsFromOpkcAPI = async (organizationUeid: string, bankUeid: string) => {
  return fetchData(
    `/ui/front-api/private/organizations/${organizationUeid}/banks/${bankUeid}/merchants/refresh-from-opkc`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const postMerchantsRefreshAPI = async (organizationUeid: string, bankUeid: string) => {
  return fetchData(
    `/ui/front-api/private/organizations/${organizationUeid}/banks/${bankUeid}/merchants/refresh-from-opkc`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const postMerchantEmitTokenAPI = async (
  organizationUeid: string,
  bankUeid: string,
  merchantUeid: string,
  data: any = {}
) => {
  return fetchData(
    `/ui/front-api/private/organizations/${organizationUeid}/banks/${bankUeid}/merchants/${merchantUeid}/emit-token`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    },
    false
  );
};

export const postMerchantRevokeTokenAPI = async (
  organizationUeid: string,
  bankUeid: string,
  merchantUeid: string
) => {
  return fetchData(
    `/ui/front-api/private/organizations/${organizationUeid}/banks/${bankUeid}/merchants/${merchantUeid}/revoke-token`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const deleteMerchantAPI = async (
  organizationUeid: string,
  bankUeid: string,
  merchantUeid: string
) => {
  return fetchData(
    `/ui/front-api/private/organizations/${organizationUeid}/banks/${bankUeid}/merchants/${merchantUeid}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};
